const Intro = () => {
  return (
    <div className="intro">
      <div className="intro-content">
        <h1 className="intro-title">Jyoti Prakash</h1>

        <div className="loader">
          <div className="loader-bar"></div>
        </div>
      </div>
    </div>
  );
};

export default Intro;